module.exports = {
  td: {
    on: true,
    host: "in.treasuredata.com",
    pathname: "/js/v3/event/",
    writeKey: "8690/54eacf81da6da22279d9284bc95a632f90352249",
    startInSignedMode: true,
    database: null
  },
  db: {
    pid: "15691",
    psign: "11eb80f2ea9076aa4983d6859ffb94f6"
  },
  cmp: {
    t: null,
    ua: null
  }
}
